import { InputProps, TextField, TextFieldProps } from '@mui/material';
import { ReactNode } from 'react';
import { alertIcon } from './icons';

type Props = Omit<TextFieldProps, 'variant'> & {
  icon?: ReactNode;
};

export function LeadFormInput({ value, icon, ...rest }: Props) {
  const slotInputProps: InputProps = {
    endAdornment: rest.error ? alertIcon : null,
    sx: {
      height: '44px',
      fontSize: '1rem',
      fontWeight: '400 !important',
    },
  };
  if (icon) {
    slotInputProps.startAdornment = icon;
  }

  return (
    <TextField
      {...rest}
      fullWidth
      variant="outlined"
      slotProps={{
        input: slotInputProps,
        htmlInput: {
          'data-treedistestid': `input-${
            rest.placeholder?.toLowerCase().replace(/\s+/g, '-') || 'text'
          }-field`,
        }
      }}
      sx={{
        '.MuiFormHelperText-root': {
          fontSize: '0.8rem',
          marginLeft: '3px',
          marginRight: '3px',
        },
        '&>.MuiInputBase-root svg': {
          color: 'grey.500',
        },
        '.MuiInputBase-input': {
          paddingY: 0,
          paddingInlineStart: '10px',

          '&:-webkit-autofill': {
            borderRadius: 'inherit',
          },
        },

        '.MuiOutlinedInput-notchedOutline': {
          marginTop: '5px',

          '&>legend': {
            display: 'none',
          },
        },

        '.MuiInputBase-root': {
          '& input:-webkit-autofill': {
            WebkitTextFill: 'inherit',
            WebkitBoxShadow: '0 0 0 100px #e8f0fe inset',
          },
        },
      }}
      value={value}
    />
  );
}
